<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="unidadesMedidas.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="unidadesMedidas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma unidade de medida encontrada"
      loading-text="Carregando unidades de medida..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao | naoInformado }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasRoleCadastroProduto">
        <v-btn icon
               @click="goToEditUnidade(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    unidadesMedidas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  computed: {
    ...mapGetters('user', ['hasRoleCadastroProduto']),
  },
  data() {
    return {
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Situação',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditUnidade(item) {
      this.$router.push({
        name: 'main.unidades.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta unidade de medida?',
        'A unidade de medida será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
